module.exports = __webpack_public_path__ + "img/paper-clipboard-holder-with-wrong-checklist.ae5c10f2.png";